export const DEFAULT_VOTE_TYPE = '1';
export default class DealVote {
    constructor(postId, vote, forumId) {
        this.postId = postId;
        this.vote = vote;
        this.forumId = forumId;
        this.voteTypeId = DEFAULT_VOTE_TYPE;
    }
    setVoteTypeId(voteTypeId) {
        this.voteTypeId = voteTypeId;
    }
    getPostId() {
        return this.postId;
    }
    getVote() {
        return this.vote;
    }
    getVoteTypeId() {
        return this.voteTypeId;
    }
    getForumId() {
        return this.forumId;
    }
}
